

const TypingDotSpinner = () => {
    return (
        <div className='flex space-x-2'>
            <div className='h-1.5 w-1.5 bg-primary rounded-full animate-bounce [animation-delay:-0.3s]' />
            <div className='h-1.5 w-1.5 bg-primary rounded-full animate-bounce [animation-delay:-0.15s]' />
            <div className='h-1.5 w-1.5 bg-primary rounded-full animate-bounce' />
        </div>
    )
}

export default TypingDotSpinner;